import { z } from "zod";

export const PublicListingSchema = z.object({
  id: z.string().uuid(),
  slug: z.string(),
  status: z.enum(["disponibile", "prezzo_su_richiesta", "in_trattativa", "riservato"]),
  kind: z.enum(["immobile", "cantiere"]),
  title: z.record(z.string()),                 // {it,en,de}
  description: z.record(z.string()),
  city: z.string(),
  zone: z.string().nullable(),
  province: z.string(),
  region: z.string(),
  country: z.string(),
  lat: z.number().nullable(),
  lng: z.number().nullable(),
  prezzo: z.number().nullable(),
  prezzo_visible: z.boolean(),
  mq: z.number().nullable(),
  rooms: z.number().nullable(),
  bathrooms: z.number().nullable(),
  ape: z.string(),                              // energy class A4..G
  ipe: z.number().nullable(),                   // kWh/m²/year
  piano: z.string(),
  disponibilita: z.string(),
  features: z.array(z.string()),
  media: z.array(z.object({
    id: z.string().uuid(),
    kind: z.enum(["photo", "render", "video", "tour_360", "floorplan"]),
    url: z.string().url(),
    width: z.number().nullable(),
    height: z.number().nullable(),
    alt: z.record(z.string()),
    caption: z.record(z.string()),
    position: z.number(),
    is_cover: z.boolean(),
  })),
  published_at: z.string(),                     // ISO timestamp
});
export type PublicListing = z.infer<typeof PublicListingSchema>;

export const PublicListingSummarySchema = PublicListingSchema.pick({
  id: true, slug: true, status: true, kind: true, title: true,
  city: true, zone: true, prezzo: true, prezzo_visible: true,
  mq: true, rooms: true, ape: true, lat: true, lng: true,
  bathrooms: true, features: true,
}).extend({
  cover_url: z.string().url().nullable(),
});
export type PublicListingSummary = z.infer<typeof PublicListingSummarySchema>;
